import React from 'react'
import poweredby from '../../assets/images/poweredby.svg'
import { useTranslation } from 'react-i18next'

const PoweredBy = () => {
    const { t } = useTranslation()

    return (
        <div className='powered-by'>
            <div>
                <img src={poweredby} alt='' className='' />
            </div>
            <div className='w-100 d-flex justify-content-center my-3'>
                <div className='content text-center'>
                    <span className='f16 fw400'>{t("powered_by_text")}</span>
                </div>
            </div>
        </div>
    )
}

export default PoweredBy
